export default __STORYBOOKCLIENTLOGGER__;
const { deprecate, logger, once, pretty } = __STORYBOOKCLIENTLOGGER__;
export { deprecate, logger, once, pretty };